import TImelinesPagePersonalArea from './TImelinesPagePersonalArea';

export default TImelinesPagePersonalArea;
